import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import {
  ellipsisCrudOptions,
  ellipsisSubHeaderOptions,
} from 'src/app/modules/crm/shared/constants/ellipsis-options';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationService } from 'primeng/api';
import { ServicerServiceArea } from '../servicer-rates.service';
import { PriceTable } from '../../../../crm-coverage/coverage-models';
import { buttonStatus } from '../../../../shared/constants/button-class';
import { KeyMap } from '../../../../shared/interface/key-map.interface';
import { ServicerService } from '../../servicer.service';
import { MessageService } from 'primeng/api';
import { validateInput } from 'src/app/modules/crm/shared/utilities/common-utilities';
import { generalDateFormatter } from 'src/app/modules/crm/shared/utilities/date-utilities';
import { AzureLoginService } from 'src/app/services/azure-login.service';
import { RolePermissionService } from 'src/app/modules/crm/common/role-permission.service';

@Component({
  standalone: false,
  selector: 'extra-mileage-section',
  templateUrl: 'extra-mileage.template.html',
  providers: [MessageService],
})
export class RatesExtraMileageComponent implements OnInit {
  dataList: any[];
  cols: any[];
  btnStatus: any = buttonStatus;
  selectedItem: any;
  ellipsisOptions: any[] = ellipsisCrudOptions;
  ellipsisHeaderOptions: any[] = ellipsisSubHeaderOptions;
  ellipsisOptionsSec: any;
  ellipsisHeaderOptionsSec: any;
  selectedEllipsisItem: any;
  clonedRowData: KeyMap = {};
  isEditing: boolean;
  editConstant: string;
  selectedRowIndex: number;
  selectedColumns: any[];
  primaryAddress: string;
  dropdown: any;
  currentId = 0;
  validateInput = validateInput;
  constructor(
    private servicerServiceArea: ServicerServiceArea,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private servicerService: ServicerService,
    private messageService: MessageService,
    private azureService: AzureLoginService,
    private rps: RolePermissionService,
  ) {
    if (!['Admin', 'Claims Manager', 'Special Team A-CC-SN'].includes(this.azureService.roleName)) {
      this.ellipsisOptions = this.ellipsisOptions.filter((x) => x.value !== 'delete');
    }
  }

  ngOnInit() {
    this.editConstant = uuidv4();

    const tableData = [];
    if (this.servicerService.servicerExtraMilage) {
      for (const info of this.servicerService.servicerExtraMilage) {
        // format date
        const servicerExtraMilage = Object.assign({}, info);
        servicerExtraMilage.effectiveDateFormatted = null;
        if (servicerExtraMilage.effectiveDate && servicerExtraMilage.effectiveDate !== '') {
          servicerExtraMilage.effectiveDateFormatted = generalDateFormatter(
            servicerExtraMilage.effectiveDate,
          );
        }

        // set range
        servicerExtraMilage.range = `$${
          servicerExtraMilage.mileRageFrom ? servicerExtraMilage.mileRageFrom.toFixed(2) : ''
        }-$${servicerExtraMilage.mileRangeTo ? servicerExtraMilage.mileRangeTo.toFixed(2) : ''}`;
        servicerExtraMilage.percentageFormatted = `${servicerExtraMilage.percentage}%`;

        // set id for edit
        servicerExtraMilage[`id`] = this.currentId = this.currentId + 1;
        tableData.push(servicerExtraMilage);
      }
    }
    this.dataList = tableData;

    this.cols = [
      { field: 'effectiveDateFormatted', header: 'EFFECTIVE DATE', type: 'date' },
      { field: 'description', header: 'DESCRIPTION', type: 'text' },
      { field: 'range', header: 'MILE RANGE', type: 'text' },
      { field: 'rate', header: 'RATE', type: 'text' },
      // { field: 'term', header: 'TERM', type: 'text' }
    ];
    this.doEvaluateRolePermissions();
  }

  doEvaluateRolePermissions() {
    this.ellipsisHeaderOptionsSec = {
      type: 'three-dots',
      operation: 'ADD',
      permission: 'Service Rates',
      category: 'Servicer',
    };
    this.ellipsisHeaderOptions = this.rps.evaluate(
      this.ellipsisHeaderOptionsSec,
      this.ellipsisHeaderOptions,
    );
    this.ellipsisOptionsSec = {
      type: 'three-dots',
      operation: 'EDIT-DELETE',
      permission: 'Service Rates',
      category: 'Servicer',
    };
    this.ellipsisOptions = this.rps.evaluate(this.ellipsisOptionsSec, this.ellipsisOptions);
  }

  ellipsisClick(event, item, Popover: Popover, rowIndex) {
    this.selectedItem = item;
    this.selectedRowIndex = rowIndex;
    toggleEllipsisPopover(event, Popover);
  }

  ellipsisOptionClick(event) {
    // ellipsis functionality goes here
  }

  onRowEdit() {
    this.isEditing = true;
    document.getElementById(this.editConstant + this.selectedItem.id).click();
  }

  onRowEditInit(rowData: any) {
    this.clonedRowData[rowData.id] = { ...rowData };
  }
  onRowEditSave(rowData: any, index: number) {
    delete this.clonedRowData[rowData.id];
    rowData.effectiveDateFormatted = generalDateFormatter(rowData.effectiveDateFormatted);
    [rowData.mileRageFrom, rowData.mileRangeTo] = rowData.range
      ? rowData.range.split('-')
      : [null, null];
    rowData.insertUserName = this.azureService.accountId;
    let payLoad = {
      ...rowData,
      effectiveDate: rowData.effectiveDateFormatted,
    };
    if (rowData.isNew) {
      payLoad = {
        servicerExtraMilageIdOriginal: rowData.servicerExtraMilageIdOriginal,
        servicerProfileId: this.servicerService.serviceFormData.servicerProfilesIdOriginal,
        servicerNumber: this.servicerService.serviceFormData.servicerNumber,
        effectiveDate: rowData.effectiveDateFormatted,
        description: rowData.description,
        mileRageFrom: rowData.mileRageFrom,
        mileRangeTo: rowData.mileRangeTo,
        rate: rowData.rate,
        term: rowData.term,
        insertUserName: rowData.insertUserName,
        addedTimeStamp: rowData.addedTimeStamp,
        isDeleted: rowData.isDeleted,
      };
    }

    this.servicerServiceArea.isLoading.next(true);
    this.servicerService.createUpdateServicerExtraMilage(payLoad).subscribe(
      (data) => {
        this.isEditing = false;
        this.servicerServiceArea.isLoading.next(false);

        this.dataList[index].servicerExtraMilageIdOriginal =
          data[`data`][`createUpdateServicerExtraMilage`] &&
          data[`data`][`createUpdateServicerExtraMilage`][`servicerExtraMilageIdOriginal`];
        this.dataList[index].servicerNumber = this.servicerService.serviceFormData.servicerNumber;
        this.dataList[index].servicerProfileId =
          this.servicerService.serviceFormData.servicerProfilesIdOriginal;

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Saved successfully.',
        });
      },
      (err) => {
        this.isEditing = false;
        this.servicerServiceArea.isLoading.next(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There was an error.',
        });
      },
    );
  }

  onRowEditCancel(rowData: any, index: number) {
    if (rowData[`isNew`]) {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to discard, these changes?',
        accept: () => {
          this.dataList[index] = this.clonedRowData[rowData.id];
          delete this.clonedRowData[rowData.id];
          this.isEditing = false;
          this.dataList.splice(this.selectedRowIndex, 1);
        },
      });
    } else {
      this.dataList[index] = this.clonedRowData[rowData.id];
      delete this.clonedRowData[rowData.id];
      this.isEditing = false;
    }
  }

  onClickAdd(event) {
    let rowItem = new PriceTable();
    rowItem.id = this.currentId = this.currentId + 1;
    rowItem[`isNew`] = true;
    rowItem = { ...rowItem };
    this.dataList.push(rowItem);
    this.cdr.detectChanges();
    this.selectedItem = rowItem;
    this.selectedRowIndex = this.dataList.length - 1;
    this.onRowEdit();
  }

  deleteExtraMileage() {
    const rowData = this.selectedItem;
    rowData.effectiveDateFormatted = generalDateFormatter(rowData.effectiveDateFormatted);
    [rowData.mileRageFrom, rowData.mileRangeTo] = rowData.range
      ? rowData.range.split('-')
      : [null, null];
    rowData.insertUserName = this.azureService.accountId;
    const payLoad = {
      ...rowData,
      effectiveDate: rowData.effectiveDateFormatted,
      isDeleted: true,
    };

    this.servicerServiceArea.isLoading.next(true);
    this.servicerService.createUpdateServicerExtraMilage(payLoad).subscribe(
      (data) => {
        this.servicerServiceArea.isLoading.next(false);
        this.dataList.splice(this.selectedRowIndex, 1);
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Deleted successfully.',
        });
      },
      (err) => {
        this.servicerServiceArea.isLoading.next(false);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'There was an error.',
        });
      },
    );
  }

  onRowDelete(event) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this row?',
      accept: () => {
        this.deleteExtraMileage();
      },
    });
  }
}
